'use strict';
'use client';
import { j as o } from "../../external/react/jsx-runtime.js";
import { faClose as m } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import { FontAwesomeIcon as h } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import e from "../../external/classnames/index.js";
import { useState as x, useEffect as v } from "react";
import { useTheme as f } from "../Provider/index.js";
const T = ({
  icon: p,
  count: l = 0,
  tooltip: n,
  className: b,
  variant: a = "alternative",
  size: s = "regular",
  ...u
}) => {
  const [d, g] = x(!1), { isMosh: r, isMoshy: t } = f(), i = l > 0;
  return v(() => {
    const c = setTimeout(() => {
      g(!0);
    }, 5e3);
    return () => {
      clearTimeout(c);
    };
  }, []), /* @__PURE__ */ o.jsxs("div", { className: "relative inline-block font-demi", children: [
    /* @__PURE__ */ o.jsxs(
      "button",
      {
        className: e(
          b,
          "relative flex items-center justify-center rounded-md ",
          s === "small" && "p-2",
          s === "regular" && "p-4",
          a === "primary" && e(" text-white", {
            "bg-purple-dark hover:bg-btn-primary-secondary-hover": t,
            "bg-orange hover:bg-orange-dark": r
          }),
          a === "alternative" && e("text-white", {
            "bg-blue hover:bg-blue-light hover:text-green-dark": t && !i,
            "bg-purple hover:bg-purple-light hover:text-purple": t && i,
            " bg-green-dark hover:bg-green-light hover:text-green": r && !i,
            "bg-green hover:bg-green-light hover:text-green": r && i
          }),
          a === "secondary" && e("border hover:text-white", {
            "border-green-dark text-green-dark hover:bg-green-dark ": r,
            "border-purple-dark text-purple-dark hover:bg-btn-primary-secondary-hover": t
          }),
          a === "secondaryLight" && e(
            "bg-transparent border-white border text-white",
            {
              " hover:bg-green-faint-dark": r,
              " hover:bg-purple-light": t
            }
          ),
          a === "tertiary" && e("hover:text-white", {
            "text-green-dark hover:bg-green-dark": r,
            "text-purple-dark hover:bg-purple-dark": t
          }),
          a === "tertiaryLight" && e(" text-white", {
            "hover:bg-green-faint-dark": r,
            "hover:bg-purple-light": t
          })
        ),
        "data-has-count": l > 0,
        ...u,
        children: [
          l > 0 ? /* @__PURE__ */ o.jsx(
            "span",
            {
              className: e(
                "absolute -top-1 -right-1 flex items-center justify-center text-xs text-white w-6 h-6 rounded-full",
                {
                  "bg-orange": r,
                  "bg-purple-dark": t
                }
              ),
              children: l > 9 ? "9+" : l
            }
          ) : null,
          /* @__PURE__ */ o.jsx(
            h,
            {
              icon: p,
              className: e(
                s === "small" && "h-[14px] w-[14px]",
                s === "regular" && "h-4 w-4"
              )
            }
          )
        ]
      }
    ),
    n ? /* @__PURE__ */ o.jsxs(
      "div",
      {
        "data-tooltip-closed": d,
        className: e(
          "flex flex-row flex-start gap-6 absolute bottom-[calc(100%_+_1rem)] right-0 p-4 rounded-lg w-52 transition-all duration-200 visible opacity-100 ",
          {
            "bg-green text-green-dark": r,
            "bg-purple-light text-purple-dark": t,
            "invisible opacity-0": d
          }
        ),
        "data-testid": "tooltip",
        children: [
          /* @__PURE__ */ o.jsx("span", { children: n }),
          /* @__PURE__ */ o.jsx(
            "button",
            {
              "data-testid": "tooltip-close",
              onClick: () => g(!0),
              className: "flex items-center justify-center w-6 h-6 ",
              children: /* @__PURE__ */ o.jsx(h, { icon: m })
            }
          ),
          /* @__PURE__ */ o.jsx(
            "div",
            {
              className: e(
                "absolute -bottom-2 right-4 border-l-8 border-l-transparent border-r-8 border-r-transparent border-t-8",
                {
                  "border-green": r,
                  "border-purple-light": t
                }
              )
            }
          )
        ]
      }
    ) : null
  ] });
};
export {
  T as default
};
